export default "__VITE_ASSET__C675bB56__"